import { Component, OnInit, Input } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { TacheService } from '../../../../services/tache.service';
import { CurrentUserService } from '../../../../services/currentUserService';
import { NbAuthService } from '@nebular/auth';
import { DatePipe } from '@angular/common';
import { Tache } from '../../../../models/tache.model';
import { TabService } from '../../../../services/tab.service';
import { TranslateService } from '@ngx-translate/core';
import { HistoTacheService } from '../../../../services/histotache.service';
import { NbToastrService } from '@nebular/theme';
const DateDiff = require('date-diff');
@Component({
  selector: 'app-tabSalle',
  templateUrl: './tabSalle.component.html',
  styleUrls: ['./tabSalle.component.scss']
})

export class TabSalleComponent implements OnInit {

  @Input() tacheSalle: Tache[];
  defaultOrdre: number;
  source: LocalDataSource;
  constructor(private tacheService:TacheService,
              private currentUserService:CurrentUserService,
              private authService: NbAuthService,
              private datePipe: DatePipe,
              private tabService: TabService,
              private translate: TranslateService,
              private histoTacheService: HistoTacheService,
              private toastrService: NbToastrService) {
  }

  ngOnInit() {
  }
  timeConvert(n: any) {
        let seconds: any = n * 60;
        let days: any = Math.floor(seconds / 86400);
        seconds -= days * 86400;
        let hours: any = Math.floor(seconds / 3600) % 24;
        seconds -= hours * 3600;
        let minutes: any = Math.floor(seconds / 60) % 60;
        if (days < 10) {
          days = '0' + days;
        }
        if (hours < 10) {
          hours = '0' + hours;
        }
        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        return days + ':' + hours + ':' + minutes;
  }

  settings = {
    pager: {
      display: true,
      perPage: 5
    },
    actions: { add:false, delete: false },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave: true,
      mode: 'inline',
    },
    columns: {
      tache_etagereId: {
        title: this.translate.instant('ESTANTE'),
        type: 'string',
        editable: false,
      },
      tache_statut: {
        title: this.translate.instant('STATUS'),
        type: 'date',
        valuePrepareFunction: (value) => {
          value = this.translate.instant('STATUS_' + value);
          return  value ;

        },
        editable: false,
      },
      typetache_libelle: {
        title: this.translate.instant('TASK_TYPE'),
        type: 'string',
        editable: false,
      },
      tache_datedebuttache: {
        title: this.translate.instant('TASK_START'),
        type: 'date',
        editable: false,
        valuePrepareFunction: (date) => { 
          const formatted = this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss');
          return formatted;
        }
      },
      tache_datefintache: {
        title: this.translate.instant('TASK_END'),
        type: 'date',
        editable: false,
        valuePrepareFunction: (date) => { 
          const formatted = this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss');
          return formatted;
        }
      },
      tempsRestant: {
        title: this.translate.instant('REMAINING_TIME'),
        type: 'date',
        editable: false,
        valuePrepareFunction:  (cell, row) => {
          const dateNow = new Date(); 
          const dateFinTache = new Date(row.tache_datefintache);
          const diff = new DateDiff(dateFinTache, dateNow);
          return this.timeConvert(diff.minutes());
        }
      },
    },
    rowClassFunction: (row) => {
      if (this.translate.instant('STATUS_' + row.data.tache_statut) === 'Terminé') {
          return 'termine';
      } else {
          return 'enCours';
      }
    },
  };

  onEditConfirm(event): void {

    if (window.confirm(this.translate.instant('TACHE_EDIT_CONFIRM'))) {
      event.newData['utilisateurId'] = this.currentUserService.user;
      this.tacheService.update_tache(event.newData)
      .subscribe(response => {
        event.newData = response;
        event.newData.forEach(property => {
          const value = event.newData[property];
          delete event.newData[property];
          property = 'tache_' + property;
          event.newData[property] = value;
        });
        event.confirm.resolve(event.newData);
        this.toastrService.success(this.translate.instant('TASK_MODIFIED'),
        this.translate.instant('SUCCESS'));
        this.histoTacheService.createHistotaches(event.newData)
          .subscribe(response => {
          this.toastrService.success(this.translate.instant('TASK_MODIFIED'),
          this.translate.instant('SUCCESS'));
          },
          (err) => {
            err.error.forEach(error => {
              this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
                                        this.translate.instant('ERROR_INVALID_TYPE'));
            });
          });
      },
      (err) => {
        err.error.forEach(error => {
          this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
                                    this.translate.instant('ERROR_INVALID_TYPE'));
        });
      });
      this.histoTacheService.createHistotaches(event.newData)
      .subscribe(response => {
        event.confirm.resolve(event.newData);
        this.toastrService.success(this.translate.instant('TASK_MODIFIED'),
        this.translate.instant('SUCCESS'));
      },
      (err) => {
        err.error.forEach(error => {
          this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
                                    this.translate.instant('ERROR_INVALID_TYPE'));
        });
      });

    } else {
      event.confirm.reject();
    }
  }
}
